import React from 'react';
import AsideContents from './AsideContents';

const Aside = () => (
  <aside className="aside">
    <AsideContents />
  </aside>
);

export default Aside;



// WEBPACK FOOTER //
// ./src/reactModules/pages/Profile/components/Aside/index.js